export const hiddenSecurityPart = (securePart: unknown): string => {
  if (typeof securePart !== "string") {
    return "";
  }

  return securePart.replace(/<security>[\s\S]*?<\/security>/g, "");
};
